import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  animate?: boolean;
}

const ForwardIcon: React.FC<Props> = (props) => {
  const { animate, ...svgProps } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="21"
      height="20"
      viewBox="0 0 21 20"
      fill="none"
      role="img"
      aria-labelledby="titleId"
      {...svgProps}
      aria-label="forward icon"
    >
      {/* <title>forward icon</title> */}
      <path
        d="M3.34628 16.2414L9.37631 11.217V8.28462L3.34628 3.26053C2.62092 2.65823 1.5 3.16384 1.5 4.12618V15.374C1.5 16.3364 2.62092 16.8427 3.34628 16.2414ZM12.347 16.2414L19.0979 10.6474C19.634 10.1949 19.634 9.36862 19.0979 8.9161L12.347 3.32206C11.6217 2.72011 10.5007 3.2254 10.5007 4.18771V15.4356C10.5011 16.3364 11.6227 16.8427 12.347 16.2414Z"
        fill={
          animate
            ? "url(#linearGradient)"
            : props.fill || "currentColor" || "white"
        }
      />

      {animate && (
        <defs>
          <linearGradient id="linearGradient">
            <stop offset="0%" stopColor="#fff">
              <animate
                attributeName="stop-color"
                values="#fff;transparent"
                dur="750ms"
                repeatCount="indefinite"
              />
            </stop>
            <stop offset="100%" stopColor="transparent">
              <animate
                attributeName="stop-color"
                values="transparent;#fff;transparent"
                dur="750ms"
                repeatCount="indefinite"
              />
            </stop>
          </linearGradient>
        </defs>
      )}
    </svg>
  );
};

export default ForwardIcon;
